<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="row">
      <div class="col-md-12">
        <div class="title-wrapper">
          <div>
            <h1 class="title-default">{{isEditMode? 'Editar' : 'Nova'}} embalagem</h1>
            <p class="welcome-message">
              <button mat-icon-button routerLink="/cadastros/embalagens">
                <mat-icon>arrow_back</mat-icon>
              </button>
              {{ isEditMode ? 'Atualize os dados da embalagem abaixo.' : 'Preencha os dados da nova embalagem para o
              sistema.' }}
            </p>
          </div>
        </div>
      </div>
    </div>

    @if (isLoading) {
    <div class="row">
      <div class="col-12 mb-4">
        <app-loading-box [height]="'30'" [width]="'250'" [margin]="'0 0 20px 0'"></app-loading-box>

        <div class="row">
          <div class="col-8 mb-3">
            <app-loading-box [height]="'56'"></app-loading-box>
          </div>
          <div class="col-4 mb-3">
            <app-loading-box [height]="'56'"></app-loading-box>
          </div>
          <div class="col-4 mb-3">
            <app-loading-box [height]="'56'"></app-loading-box>
          </div>
          <div class="col-4 mb-3">
            <app-loading-box [height]="'56'"></app-loading-box>
          </div>
          <div class="col-4 mb-3">
            <app-loading-box [height]="'56'"></app-loading-box>
          </div>
        </div>
      </div>
    </div>
    } @else {
    <form [formGroup]="form" (ngSubmit)="salvar()">
      <!-- Seção: Informações da Embalagem -->
      <div class="section-container">
        <div class="row">
          <div class="col-12 col-md-8">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Descrição</mat-label>
              <input matInput formControlName="descricao" placeholder="Ex: Caixa de Papelão Grande Reforçada"
                required />
              @if (form.get('descricao')?.hasError('required')) {
              <mat-error>Obrigatório</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Tipo</mat-label>
              <mat-select formControlName="idTipoEmbalagem">
                @for (tipo of listaTipoEmbalagem; track tipo.id) {
                <mat-option [value]="tipo.id">{{ tipo.descricao }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Campos para Pacote/Caixa -->
          @if (selectedTipo === TipoEmbalagemEnum.PacoteCaixa) {
          <div class="col-6 col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Largura (cm)</mat-label>
              <input matInput type="text" formControlName="larguraCm" placeholder="0,00"
                [currencyMask]="getDecimalMask(2)" />
            </mat-form-field>
          </div>
          <div class="col-6 col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Comprimento (cm)</mat-label>
              <input matInput type="text" formControlName="comprimentoCm" placeholder="0,00"
                [currencyMask]="getDecimalMask(2)" />
            </mat-form-field>
          </div>
          <div class="col-6 col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Altura (cm)</mat-label>
              <input matInput type="text" formControlName="alturaCm" placeholder="0,00"
                [currencyMask]="getDecimalMask(2)" />
            </mat-form-field>
          </div>
          <div class="col-6 col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Peso (kg)</mat-label>
              <input matInput type="text" formControlName="pesoKg" placeholder="0,000"
                [currencyMask]="getDecimalMask(3)" />
            </mat-form-field>
          </div>
          }

          <!-- Campos para Rolo/Cilindro -->
          @if (selectedTipo === TipoEmbalagemEnum.RoloCilindro) {
          <div class="col-6 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Comprimento (cm)</mat-label>
              <input matInput type="text" formControlName="comprimentoCm" placeholder="0,00"
                [currencyMask]="getDecimalMask(2)" />
            </mat-form-field>
          </div>
          <div class="col-6 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Diâmetro (cm)</mat-label>
              <input matInput type="text" formControlName="diametroCm" placeholder="0,00"
                [currencyMask]="getDecimalMask(2)" />
            </mat-form-field>
          </div>
          <div class="col-6 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Peso (kg)</mat-label>
              <input matInput type="text" formControlName="pesoKg" placeholder="0,000"
                [currencyMask]="getDecimalMask(3)" />
            </mat-form-field>
          </div>
          }

          <!-- Campos para Envelope -->
          @if (selectedTipo === TipoEmbalagemEnum.Envelope) {
          <div class="col-6 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Largura (cm)</mat-label>
              <input matInput type="text" formControlName="larguraCm" placeholder="0,00"
                [currencyMask]="getDecimalMask(2)" />
            </mat-form-field>
          </div>
          <div class="col-6 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Comprimento (cm)</mat-label>
              <input matInput type="text" formControlName="comprimentoCm" placeholder="0,00"
                [currencyMask]="getDecimalMask(2)" />
            </mat-form-field>
          </div>
          <div class="col-6 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Peso (kg)</mat-label>
              <input matInput type="text" formControlName="pesoKg" placeholder="0,000"
                [currencyMask]="getDecimalMask(3)" />
            </mat-form-field>
          </div>
          }
        </div>

        <!-- SVG Diagrams -->
        <div class="diagram-container">
          <!-- Pacote/Caixa Diagram -->
          @if (selectedTipo === TipoEmbalagemEnum.PacoteCaixa) {
          <svg class="diagram-svg" viewBox="0 0 200 180" xmlns="http://www.w3.org/2000/svg">
            <!-- Box faces -->
            <polygon points="40,60 100,30 160,60 100,90" fill="#f5f5f5" stroke="#ccc" stroke-width="1" />
            <polygon points="40,60 40,130 100,160 100,90" fill="#e8e8e8" stroke="#ccc" stroke-width="1" />
            <polygon points="100,90 100,160 160,130 160,60" fill="#ddd" stroke="#ccc" stroke-width="1" />

            <!-- Dimension lines and labels -->
            <!-- Height (A) -->
            <line x1="25" y1="60" x2="25" y2="130" stroke="#999" stroke-width="1" />
            <line x1="20" y1="60" x2="30" y2="60" stroke="#999" stroke-width="1" />
            <line x1="20" y1="130" x2="30" y2="130" stroke="#999" stroke-width="1" />
            <text x="15" y="95" font-size="12" fill="#666">A</text>

            <!-- Width (L) -->
            <line x1="40" y1="145" x2="100" y2="175" stroke="#999" stroke-width="1" />
            <line x1="40" y1="140" x2="40" y2="150" stroke="#999" stroke-width="1" />
            <line x1="100" y1="170" x2="100" y2="180" stroke="#999" stroke-width="1" />
            <text x="65" y="170" font-size="12" fill="#666">L</text>

            <!-- Depth (C) -->
            <line x1="100" y1="175" x2="160" y2="145" stroke="#999" stroke-width="1" />
            <line x1="100" y1="170" x2="100" y2="180" stroke="#999" stroke-width="1" />
            <line x1="160" y1="140" x2="160" y2="150" stroke="#999" stroke-width="1" />
            <text x="135" y="170" font-size="12" fill="#666">C</text>
          </svg>
          }

          <!-- Rolo/Cilindro Diagram -->
          @if (selectedTipo === TipoEmbalagemEnum.RoloCilindro) {
          <svg class="diagram-svg" viewBox="0 0 200 150" xmlns="http://www.w3.org/2000/svg">
            <!-- Cylinder body -->
            <ellipse cx="50" cy="75" rx="20" ry="40" fill="#e8e8e8" stroke="#ccc" stroke-width="1" />
            <rect x="50" y="35" width="100" height="80" fill="#f5f5f5" stroke="none" />
            <line x1="50" y1="35" x2="150" y2="35" stroke="#ccc" stroke-width="1" />
            <line x1="50" y1="115" x2="150" y2="115" stroke="#ccc" stroke-width="1" />
            <ellipse cx="150" cy="75" rx="20" ry="40" fill="#ddd" stroke="#ccc" stroke-width="1" />

            <!-- Dimension lines and labels -->
            <!-- Diameter (D) -->
            <line x1="150" y1="35" x2="150" y2="115" stroke="#999" stroke-width="1" stroke-dasharray="4,2" />
            <line x1="165" y1="35" x2="175" y2="35" stroke="#999" stroke-width="1" />
            <line x1="165" y1="115" x2="175" y2="115" stroke="#999" stroke-width="1" />
            <line x1="170" y1="35" x2="170" y2="115" stroke="#999" stroke-width="1" />
            <text x="175" y="80" font-size="12" fill="#666">D</text>

            <!-- Length (C) -->
            <line x1="50" y1="130" x2="150" y2="130" stroke="#999" stroke-width="1" />
            <line x1="50" y1="125" x2="50" y2="135" stroke="#999" stroke-width="1" />
            <line x1="150" y1="125" x2="150" y2="135" stroke="#999" stroke-width="1" />
            <text x="95" y="145" font-size="12" fill="#666">C</text>
          </svg>
          }

          <!-- Envelope Diagram -->
          @if (selectedTipo === TipoEmbalagemEnum.Envelope) {
          <svg class="diagram-svg" viewBox="0 0 200 150" xmlns="http://www.w3.org/2000/svg">
            <!-- Envelope body -->
            <rect x="30" y="30" width="140" height="90" fill="#f5f5f5" stroke="#ccc" stroke-width="1" rx="2" />
            <!-- Envelope flap -->
            <polygon points="30,30 100,70 170,30" fill="#e8e8e8" stroke="#ccc" stroke-width="1" />

            <!-- Dimension lines and labels -->
            <!-- Height (L) -->
            <line x1="185" y1="30" x2="185" y2="120" stroke="#999" stroke-width="1" />
            <line x1="180" y1="30" x2="190" y2="30" stroke="#999" stroke-width="1" />
            <line x1="180" y1="120" x2="190" y2="120" stroke="#999" stroke-width="1" />
            <text x="188" y="80" font-size="12" fill="#666">L</text>

            <!-- Width (C) -->
            <line x1="30" y1="135" x2="170" y2="135" stroke="#999" stroke-width="1" />
            <line x1="30" y1="130" x2="30" y2="140" stroke="#999" stroke-width="1" />
            <line x1="170" y1="130" x2="170" y2="140" stroke="#999" stroke-width="1" />
            <text x="95" y="148" font-size="12" fill="#666">C</text>
          </svg>
          }
        </div>
      </div>
    </form>
    }
  </div>
</div>

<app-footer-action [isLoadingSalvar]="isSaving" (cancelar)="cancelar()" (salvar)="salvar()"></app-footer-action>